import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PdBusinessData } from '../pd-collect-data.store';
import { CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input-gg';

@Component({
  selector: 'app-pd-business-data',
  templateUrl: './pd-business-data.component.html',
})
export class PdBusinessDataComponent {
  protected readonly CountryISO = CountryISO;

  @Input() public showBackButton = true;

  @Input() set data(data: PdBusinessData | undefined | null) {
    if (data) {
      this.formGroup.patchValue(
        {
          companyName: data.companyName,
          businessNumber: data.businessNumber,
          addressCity: data.addressCity,
          addressStreet: data.addressStreet,
          addressNumber: data.addressNumber,
          vendorNumber: data.vendorNumber,
          // TODO: check phone number
          phone: data.phone,
        },
        { emitEvent: false },
      );
    }
  }

  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<PdBusinessData>();

  public formGroup = new FormGroup({
    companyName: new FormControl<string>(''),
    businessNumber: new FormControl<number | null>(null, [Validators.pattern('^[0-9]*$')]),
    addressCity: new FormControl<string>(''),
    addressStreet: new FormControl<string>(''),
    addressNumber: new FormControl<string>(''),
    vendorNumber: new FormControl<string>('', [Validators.pattern('^[0-9]*$')]),
    // TODO: consider lib replace
    phone: new FormControl<any>(''),
  });

  public submit() {
    this.next.emit({
      companyName: this.formGroup.get('companyName')!.value,
      businessNumber: this.formGroup.get('businessNumber')!.value,
      addressCity: this.formGroup.get('addressCity')!.value,
      addressStreet: this.formGroup.get('addressStreet')!.value,
      addressNumber: this.formGroup.get('addressNumber')!.value,
      vendorNumber: this.formGroup.get('vendorNumber')!.value,
      phone: this.formGroup.get('phone')!.value?.internationalNumber.replaceAll(new RegExp('[^0-9+]', 'g'), '') || null,
    });
  }

  public goBack() {
    this.back.emit();
  }

  protected readonly PhoneNumberFormat = PhoneNumberFormat;
}
